import React from 'react';
import { useTranslation } from 'react-i18next';
import WarningMessage from './WarningMessage';

interface IProps {
  isError: boolean;
  inputError: string;
  isNoProductFound: boolean;
  isNoCrossesFound: boolean;
  isFetching: boolean;
  tabId: string;
  isDefaultReverseView: boolean;
}

const WarningMessageContainer: React.FC<IProps> = ({
  isError,
  inputError,
  isNoProductFound,
  isNoCrossesFound,
  isFetching,
  tabId,
  isDefaultReverseView
}) => {
  const { t } = useTranslation();

  const WERE_NOT_FIND = `<strong>${t('xref-no-results')}</strong> ${t(
    'xref-no-results-1'
  )} ${t('xref-no-results-2')}<br>${t('xref-techforum-message-no-result')}`;
  const NO_CROSSES_FOUND = `<strong>${t('xref-no-cross-results')}</strong> ${t(
    'xref-no-cross-results-1'
  )}<br>${t('xref-techforum-message-no-cross')}`;
  const GUIDE_REVERSE_SEARCH = `${t('xref-use-the-reverse-lookup-tab')}`;

  const EXPERIENCED_MESSAGE = `<strong>${t('xref-sorry')}</strong> ${t(
    'xref-sorry-1'
  )}`;
  return (
    <>
        {isError && !inputError && (
          <WarningMessage
            data-testid="error-message"
            message={EXPERIENCED_MESSAGE}
          />
        )}

      {tabId === 'tabReverseLookup' ? (
        <>
            {isDefaultReverseView &&
            (isNoCrossesFound && !isFetching && !inputError) ? (
              <WarningMessage
                message={NO_CROSSES_FOUND}
                colorGround={'#FDF8E6'}
              />
            ) : null}
            {!isFetching && !inputError ? (
              <WarningMessage message={GUIDE_REVERSE_SEARCH} />
            ) : null}
        </>
      ) : (
        <>
          {isNoProductFound ? (
            <>
              {!isFetching && !inputError ? (
                <WarningMessage message={WERE_NOT_FIND} />
              ) : null}
            </>
          ) : (
            <>
                {isNoCrossesFound && !isFetching && !inputError ? (
                  <WarningMessage message={NO_CROSSES_FOUND} />
                ) : null}
            </>
          )}
        </>
      )}
    </>
  );
};

export default WarningMessageContainer;
